import { useId } from 'react'
import { MAINTENANCE_LOGS_ALL_SENTINEL } from '@/shared/lib/maintenanceLogsFilterParams'
import { orgFilterNeedsSearch } from '@/shared/lib/orgFilterNeedsSearch'
import { Label } from '@/shared/ui/label'
import { SearchableSelect } from '@/shared/ui/searchable-select'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select'

interface OrgEntityOption {
  value: number
  label: string
}

interface OrgEntityFilterSelectProps {
  label: string
  value: string
  onValueChange: (value: string) => void
  allLabel: string
  entityOptions: OrgEntityOption[]
  triggerClassName: string
}

/** Site / Department / Unit: SearchableSelect when entity options > 5 (legacy showSearch). */
const OrgEntityFilterSelect = ({
  label,
  value,
  onValueChange,
  allLabel,
  entityOptions,
  triggerClassName,
}: OrgEntityFilterSelectProps) => {
  const controlId = useId()
  const selectOptions = [
    { value: MAINTENANCE_LOGS_ALL_SENTINEL, label: allLabel },
    ...entityOptions.map((entityOption) => ({
      value: String(entityOption.value),
      label: entityOption.label,
    })),
  ]

  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={controlId} className="text-xs text-muted-foreground">
        {label}
      </Label>
      {orgFilterNeedsSearch(entityOptions.length) ? (
        <SearchableSelect
          id={controlId}
          aria-label={label}
          className={triggerClassName}
          value={value}
          onValueChange={onValueChange}
          placeholder={allLabel}
          options={selectOptions}
        />
      ) : (
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger id={controlId} className={triggerClassName}>
            <SelectValue placeholder={allLabel} />
          </SelectTrigger>
          <SelectContent>
            {selectOptions.map((selectOption) => (
              <SelectItem key={selectOption.value} value={selectOption.value}>
                {selectOption.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  )
}

export default OrgEntityFilterSelect
